import React, {useState, useEffect, useContext, useRef} from "react";

import {DEFAULT_BLUE} from "../../constants/general-constants";
import {useHistory} from 'react-router-dom';
import {functions} from "../../constants/common-functions";
import {store} from '../../context/store';
import {NO_STRINGIFY} from "../../constants/general-constants";
import {JWT} from "../../constants/local-storage";
import CircularProgress from '@material-ui/core/CircularProgress';
import AdministrationClientHomeLink from '../administration/components/AdministrationClientHomeLink';

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationClient(){
	const history = useHistory(); 
	const [displayProgress, setDisplayProgress] = useState("none");
	const refClientHomeBanner = useRef(null);
	const refClientHomeStrap = useRef(null);
	const refFileBackground = useRef(null);
	const refFileLogo = useRef(null);
	const refFileLogoDark = useRef(null);
	const refFileLogoSecond = useRef(null);
	const refClientColor = useRef(null);
	
	const [sourceBackground, setSourceBackground] = useState("");
	const [nameBackground, setNameBackground] = useState("");
	
	const [sourceLogo, setSourceLogo] = useState("");
	const [nameLogo, setNameLogo] = useState("");
	
	const [sourceLogoDark, setSourceLogoDark] = useState("");
	const [nameLogoDark, setNameLogoDark] = useState("");
	
	const [sourceLogoSecond, setSourceLogoSecond] = useState("");
	const [nameLogoSecond, setNameLogoSecond] = useState("");
	
	const [homepageLinks, setHomepageLinks] = useState([]);
	
	useEffect(() => {
		loadData();
	}, []);
	
	const loadData = () => {
		functions.getObjectFromAjax("/resolution/getclient", null, populateForm);
		functions.getObjectFromAjax("/resolution/clienthomepagelinks", null, setHomepageLinks);
	};
	
	const populateForm = (client) => {
		refClientHomeBanner.current.value = client.homeBannerTitle;
		refClientHomeStrap.current.value = client.homeBannerStrap;
		refClientColor.current.value = client.colorPrimary
		
		try{
				let initialBackground = client.resourceFolderUrl + "/cover.jpg";
				functions.getFileSource(initialBackground,
					setSourceBackground, setNameBackgroundToValue);
			}
			catch(e){
				
			}	
			
			try{
				let initialLogo = client.resourceFolderUrl + "/client_logo.png";
				functions.getFileSource(initialLogo,
					setSourceLogo, setNameLogoToValue);
			}
			catch(e){
				
			}	
			
			try{
				let initialLogoDark = client.resourceFolderUrl + "/client_logo_dark.png";
				functions.getFileSource(initialLogoDark,
					setSourceLogoDark, setNameLogoDarkToValue);
			}
			catch(e){
				
			}	
			
			try{
				let initialLogoSecond = client.resourceFolderUrl + "/second_logo.png";
				functions.getFileSource(initialLogoSecond,
					setSourceLogoSecond, setNameLogoSecondToValue);
			}
			catch(e){
				
			}	
	};
	
	const setNameBackgroundToValue = () => {
		setNameBackground("cover.jpg");
	};
	
	const setNameLogoToValue = () => {
		setNameLogo("client_logo.png");
	};
	
	const setNameLogoDarkToValue = () => {
		setNameLogoDark("client_logo_dark.png");
	};
	
	const setNameLogoSecondToValue = () => {
		setNameLogoSecond("second_logo.png");
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const mainTitle = {
		display:"flex",
		marginLeft:"20px",
		height:"60px",
		fontSize:"21px",
		alignItems:"center"	
	};
	
	const contentRow = {
		display:"flex",
		height:"40px",
		alignItems:"center"
	};
	
	const label = {
		display:"flex",
		marginLeft:'20px',
		fontSize:"12px",
		width:"300px"
	};
	
	const inputColumn = {
		display:"flex"
	};
	
	const textInput = {
		display:"flex",
		height:"30px",
		border:"1px solid #999",
		paddingLeft:"10px",
		fontSize:'12px',
		width:'500px'
	};
	
	const photoEditRow = {
		display:"flex",
		marginTop:"10px",
		marginLeft:"10px",
		marginBottom:"10px"
	};
	
	const photoContainer = {
		display:"flex",
		width:"150px",
		height:"80px",
		border:"1px solid darkgrey",
		color:"black",
		fontSize:"12px",
		justifyContent:"space-around",
		alignItems:"center",
		marginRight:"10px"
	};
	
	const photoStyle = {
		display:"flex",
		width:"100%",
		maxHeight:"80px"
	};
	
	const photoInput = {
		display:"flex",
		width:"200px",
		height:"30px"
	};
	
	const getBackgroundDisplay = () => {
		if(nameBackground != ""){
			return <img src={sourceBackground} style={photoStyle}/>;
		}
		else{
				return "no image uploaded";
		}
	
	};
	
	const getLogoDisplay = () => {
		if(nameLogo != ""){
			return <img src={sourceLogo} style={photoStyle}/>;
		}
		else{
				return "no image uploaded";
		}
	
	};
	
	const getLogoDarkDisplay = () => {
		if(nameLogoDark != ""){
			return <img src={sourceLogoDark} style={photoStyle}/>;
		}
		else{
				return "no image uploaded";
		}
	
	};
	
	const getLogoSecondDisplay = () => {
		if(nameLogoSecond != ""){
			return <img src={sourceLogoSecond} style={photoStyle}/>;
		}
		else{
				return "no image uploaded";
		}
	
	};
	
	const info = {
		display:'flex',
		color:"red",
		fontSize:"12px",
		paddingTop:"3px"
	};
	
	const menuBar = {
		display:"flex",
	};
	
	const goUpload = () => {
		setDisplayProgress("flex");
		try{
			let formData = new FormData();
				formData.append("fileBackground", refFileBackground.current.files[0]);
				formData.append("fileLogo", refFileLogo.current.files[0]);
				formData.append("fileLogoDark", refFileLogoDark.current.files[0]);
				formData.append("fileLogoSecond", refFileLogoSecond.current.files[0]);
				formData.append("systemTitle", refClientHomeBanner.current.value);
				formData.append("strapLine", refClientHomeStrap.current.value);
				formData.append("color", refClientColor.current.value);
			
				functions.submitAjax("/resolution/voyansiclientadmin", 
					formData, saveEnd, NO_STRINGIFY, handleSubmitError);
		}
		catch(e){
			alert(e);
		}
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
		setDisplayProgress("none");
	};
	
	const saveEnd = () => {
		const timer = setTimeout(() => {
			setDisplayProgress("none");
			loadData();
		}, 2000);
	};
	
	const goBack = () => {
		history.push('/administrationhome');
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	const editButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		borderRadius:"4px",
		alignItems:"center",
		color:'white',
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:'pointer',
		border:"1px solid " +DEFAULT_BLUE,
		margin:"5px"
	};
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	const bottomContent = {
		display:"flex",
		width:"100%"
	}; 
	
	const bottomContentColumn = {
		display:"flex",
		width:"50%",
		flexDirection:"column"
	};
	
	const homepageLinkPanel = {
		display:"flex",
		margin:"10px",
		fontSize:"12px",
		color:"black"
	};
	
	const homepageLinkDisplay = homepageLinks.map((item, index) => 
		<AdministrationClientHomeLink
			id={item.id}
			name={item.name}
			color={item.color}
			sequence={item.sequence}
			link={item.link}
		/>
	);
	
	return (
	
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
					<div style={mainTitle}>
						System Look And Feel
					</div>
					<div style={contentRow}>
						<div style={label}>
							Main system title on home page
						</div>
						<div style={inputColumn}>
							<input type="text" style={textInput} ref={refClientHomeBanner}/>
						</div>
					</div>
					<div style={contentRow}>
						<div style={label}>
							System strap line on home page
						</div>
						<div style={inputColumn}>
							<input type="text" style={textInput} ref={refClientHomeStrap}/>
						</div>
					</div>
					
					<div style={contentRow}>
						<div style={label}>
							Primary Client Colour
						</div>
						<div style={inputColumn}>
							<input type="text" style={textInput} ref={refClientColor}/>
						</div>
					</div>
					
					<div style={bottomContent}>
						<div style={bottomContentColumn}>
								<div style={photoEditRow}>
									<div style={photoContainer}>
										{getBackgroundDisplay()}
									</div>
									<input type="file" ref={refFileBackground} style={photoInput}/>
									<div style={info}>
										Must be a jpg file
									</div>
								</div>
								<div style={photoEditRow}>
									<div style={photoContainer}>
										{getLogoDisplay()}
									</div>
									<input type="file" ref={refFileLogo} style={photoInput}/>
									<div style={info}>
										Must be a png file
									</div>
								</div>
								<div style={photoEditRow}>
									<div style={photoContainer}>
										{getLogoDarkDisplay()}
									</div>
									<input type="file" ref={refFileLogoDark} style={photoInput}/>
									<div style={info}>
										Must be a png file
									</div>
								</div>
								<div style={photoEditRow}>
									<div style={photoContainer}>
										{getLogoSecondDisplay()}
									</div>
									<input type="file" ref={refFileLogoSecond} style={photoInput}/>
									<div style={info}>
										Must be a png file
									</div>
								</div>
						</div>
						<div style={bottomContentColumn}>
							{homepageLinkDisplay}
						</div>
					</div>
					
				<div style={progressContainer}>
				<CircularProgress
						color="inherit"
					>
					</CircularProgress>
			</div>
			<div style={editFooter}>
				<div style={editButtonContainer}>
					<div style={editButton} onClick={goUpload}>
						Upload
					</div>
					<div style={editButton} onClick={goBack}>
						Back To Menu
					</div>
				</div>
			</div>
			</div>
			
		
	);
}